import { Flex, Spacing } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { LocalStorageKeys } from '../../../../enums/localStorageKeys'
import { SalesReportExportLimitBanner } from '../../elements/SalesReportExportLimitBanner'
import { SalesReportStatistics } from '../../elements/SalesReportStatistics'
import { useSalesOverviewReport } from '../../hooks/salesOverviewReport/useSalesOverviewReport'
import { SalesOverviewReportTable } from './elements/SalesOverviewReportTable'

export const SalesOverviewReport = () => {
  const { t } = useTranslation()
  const { salesOverviewReport, isLoading } = useSalesOverviewReport()

  return (
    <Flex flexDirection="column" width="100%" gap={Spacing.S8}>
      <SalesReportExportLimitBanner
        localStorageKey={LocalStorageKeys.HideSalesReportInvoicesExportLimitBanner}
        bannerMessage={t('sales_report.export_limit_banner.text.invoices')}
        salesReportCount={salesOverviewReport.length}
      />
      <SalesReportStatistics variant="overview" salesReport={salesOverviewReport} isLoading={isLoading} />
      <SalesOverviewReportTable />
    </Flex>
  )
}
